<script setup lang="ts">
/**
 * Value Proposition Row - TMC Professional Grade
 * 解決方案：
 * 1. 採用高密度小卡片，不佔空間但視覺強烈
 * 2. 針對 General Audience 與 Student 做出差異化文案
 */
const propositions = [
  {
    icon: "ph:shield-check-fill",
    title: "Official Sync",
    desc: "Direct NDC connect for real-time fares.",
    color: "text-brand-600",
    bg: "bg-brand-50",
  },
  {
    icon: "ph:graduation-cap-fill",
    title: "Student Perks",
    desc: "Unlock verified educational discounts.",
    color: "text-action-500",
    bg: "bg-action-50",
  },
  {
    icon: "ph:clock-clockwise-fill",
    title: "Unified Flow",
    desc: "Sync your flight with smart hotel transfers.",
    color: "text-indigo-600",
    bg: "bg-indigo-50",
  },
];
</script>
<template>
  <section class="relative z-20 max-w-7xl mx-auto px-6 lg:px-8">
    <div
      class="bg-white rounded-[1.5rem] md:rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.1)] p-4 md:p-8 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-0 divide-y md:divide-y-0 md:divide-x divide-slate-100 border border-slate-100"
    >
      <div
        v-for="prop in propositions"
        :key="prop.title"
        class="flex-1 px-4 py-4 md:py-0 md:px-10 flex items-start gap-5 group cursor-default transition-all"
      >
        <div
          :class="[prop.bg, prop.color]"
          class="w-12 h-12 rounded-xl flex items-center justify-center shrink-0 transition-transform group-hover:rotate-6 shadow-sm"
        >
          <Icon :name="prop.icon" class="text-2xl" />
        </div>
        <div>
          <h4
            class="font-black text-slate-900 text-sm uppercase tracking-widest mb-1 italic"
          >
            {{ prop.title }}
          </h4>
          <p class="text-xs text-slate-500 font-bold leading-relaxed">
            {{ prop.desc }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
